"use client"
import { createContext, useContext } from "react";
import { Tenant } from "@web-libs/features/tenant/domain/tenant.types";

export const TenantContext = createContext<Tenant | null>(null)

export const TenantProvider = ({tenant, children}: {tenant: Tenant, children: React.ReactNode}) => {
    return <TenantContext.Provider value={tenant}>{children}</TenantContext.Provider>
}

export const useTenant = () => {
    const tenant = useContext(TenantContext)
    if (!tenant) {
        throw new Error("Tenant not found")
    }
    return tenant
}
